module.exports = __webpack_public_path__ + "media/images/flip-camera-btn-284bf76ca071455bcadb9368080cd371.svg";